<template>
    <div class="card">
        <div class="card-header">
            <h5 class="me-auto">Paquetes</h5>
        </div>
        <div class="card-body p-0">
            <template>
                <v-data-table class="elevation-1" :headers="headers" :items="items.data" :options.sync="options"
                    show-expand :single-expand="true" :expanded.sync="expanded"
                    :server-items-length="items.total" :loading="loading" :footer-props="{
                        'items-per-page-options': [5, 10, 50, 100]
                    }">
                    <template v-slot:[`item.id`]="{ item }">
                        {{ item.type }}{{ item.id }}
                    </template>
                    <template v-slot:[`item.state.name`]="{ item }">
                        <span class="badge badge-pill" :class="item.state.labels ? item.state.labels : 'badge-light'">{{ item.state.name }}</span>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <v-tooltip bottom class="mx-1">
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(item.description)">
                                    {{ item.description[0] }} ...
                                </div>
                            </template>
                            <small><div v-for="(description, key) in  item.description" :key="key">{{ description }}</div></small>
                        </v-tooltip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td colspan="100%">
                            <div class="row py-2">
                                <div class="col-lg-4 mb-2">
                                    <v-tooltip bottom class="mx-1">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(item.description)">
                                                {{ item.description[0] }} ...
                                            </div>
                                        </template>
                                        <small><div v-for="(description, key) in  item.description" :key="key">{{ description }}</div></small>
                                    </v-tooltip>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;"><b>AWB:</b> {{ item.awb ? item.awb.awb : '' }}</span>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;"><b>Ruta:</b> {{ item.deliver_route ? item.deliver_route.route ? item.deliver_route.route.full_name : '' : '' }}</span>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;"><b>Valor Declarado:</b> $ {{ Number(item.value || 0).toFixed(2) }}</span>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;"><b>Creado:</b> {{ item.created_at | DATE }}</span>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;"><b>Sucursal:</b> {{ item.branch_office ? item.branch_office.name : '' }}</span>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;"><b>Tracking:</b> {{ item.tracking }}</span>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;"><b>Actualizado:</b> {{ item.updated_at | DATE }}</span>
                                </div>
                                <div class="col-lg-4 mb-2">
                                    <span style="font-size: .75rem;">
                                        <router-link :to="{ name: 'PackageDetail', params: { id: item.id } }"
                                            class="text-decoration-none text-center sortable" style="font-size: .75rem;">
                                            Más detalles...
                                        </router-link>
                                    </span>
                                </div>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            headers: [
                { text: 'GV', value: 'id', sortable: false },
                { text: 'Tracking', value: 'tracking', sortable: false },
                { text: 'Descripción', value: 'description', sortable: false },
                { text: 'Estado', value: 'state.name', sortable: false },
                { text: 'Ver Detalle', value: 'data-table-expand', sortable: false }
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: false,
            id: this.$route.params.id,
            options: {},
            expanded: [],
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            vue.loading = true
            const { page, itemsPerPage } = vue.options
            axios({
                url: '/users/' + vue.id + '/packages?page=' + page + '&itemsPerPage=' + itemsPerPage,
                method: 'GET'
            })
                .then((resp) => {
                    vue.items = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402 || err.response.status === 404) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
    },
    watch: {
        options: {
            handler() {
                this.INIT(true)
            },
            deep: true
        }
    }
}
</script>